import { css } from '@emotion/core'
import parse from 'html-react-parser'
import React from 'react'

import { ctaInlineBreakPoint, longCopyBreakPoint } from '../../constants/breakPoints'
import { breakpoints } from '../../constants/breakPoints'
import { isMobile } from '../../helpers/common'
import { CTATemplatesProps } from '../../interfaces/cta'
import { Button } from '../Button'
import Image from '../Image'
import { Link } from '../Link'
import { blueTextStyle } from './CTAEbook'

const CTATemplates: React.FunctionComponent<CTATemplatesProps> = ({
  isSidebarCta = false,
  templatesCategoryUrl = 'product-management',
}) => {
  // hide sidebar CTA on screens < longCopyBreakPoint (2 columns only - tablet & mobile: 1 column)
  if (isSidebarCta && isMobile(longCopyBreakPoint)) {
    return null
  }

  return (
    <div className="purple-bg with-box-shadow" css={containerStyle(isSidebarCta)}>
      {isSidebarCta && (
        <Link
          className="scale-on-hover"
          href={`/cta/${isSidebarCta ? 'sidebar' : 'inline'}/templates/category/${templatesCategoryUrl}/`}
          css={imageStyle(isSidebarCta)}
        >
          <Image src={`cta/templates-${templatesCategoryUrl}.webp`} alt="airfocus templates" />
        </Link>
      )}
      <div>
        <div className={`blue-text ${isSidebarCta ? 'strong-body-2' : 'heading4'}`} css={blueTextStyle(isSidebarCta)}>
          Templates
        </div>

        {isSidebarCta ? (
          <div className="cta-sidebar-title black-text">
            Get started with {templatesCategoryUrl.replace('-', ' ')} templates
          </div>
        ) : (
          <h3 className="heading3 black-text no-margin">
            Get started with {!templatesCategoryUrl.includes('-') && <br />}
            {parse(templatesCategoryUrl.replace('-', '<br class="hide-on-small" /> '))} templates
          </h3>
        )}
        <Button
          link={`/cta/${isSidebarCta ? 'sidebar' : 'inline'}/templates/category/${templatesCategoryUrl}/`}
          css={buttonStyle(isSidebarCta)}
        >
          Find template
        </Button>
      </div>

      {!isSidebarCta && (
        <Link
          className="scale-on-hover"
          href={`/cta/${isSidebarCta ? 'sidebar' : 'inline'}/templates/category/${templatesCategoryUrl}/`}
          css={imageStyle(isSidebarCta)}
        >
          <Image
            src={`cta/templates-${isMobile(breakpoints.small) ? 'small' : templatesCategoryUrl}.webp`}
            alt="airfocus templates"
          />
        </Link>
      )}
    </div>
  )
}

export default CTATemplates

const containerStyle = (isSidebarCta: boolean) => css`
  // richt-text (center column) always has a slight margin-top for which we need to align
  ${isSidebarCta ? 'margin-top: 0.25rem' : 'margin: 2rem 0'};
  ${isSidebarCta ? 'position: sticky; top: 6rem;' : 'position: relative;'};
  border-radius: 0.5rem;
  padding: ${isSidebarCta ? '1.25rem' : '2rem'};
  overflow: hidden;

  ${!isSidebarCta &&
  `
    @media screen and (min-width: ${breakpoints.small + 1}px) {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    @media screen and (max-width: ${breakpoints.medium}px) {
      padding: 2rem 2.2rem;
    }
    
    @media screen and (max-width: ${breakpoints.small}px) {
      margin-top: 3rem;
      padding: 2rem;
      overflow: initial;
    }
  `};
`

const imageStyle = (isSidebarCta: boolean) => css`
  display: block;

  ${!isSidebarCta &&
  `
    width: 238px;
    
    @media screen and (max-width: ${breakpoints.xlarge}px) and (min-width: ${longCopyBreakPoint + 1}px) {
      position: absolute;
      right: -48px;
    }
    
    @media screen and (max-width: ${ctaInlineBreakPoint}px) and (min-width: ${breakpoints.medium + 1}px) {
      position: absolute;
      left: 66%;
    }
    
    @media screen and (max-width: ${breakpoints.medium}px) {
      margin-left: 1.5rem;
    }

    @media screen and (max-width: ${breakpoints.small}px) {
      position: absolute;
      width: 4.5rem;
      top: -1.5rem;
      right: 1.5rem;
    }
    
   `}
`

const buttonStyle = (isSidebarCta: boolean) => css`
  margin-top: ${isSidebarCta ? '1rem' : '1.5rem'};
  ${isSidebarCta && 'width: 100%; padding: 0.75rem;'};
`
